var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99571 1.32904C6.45334 1.32904 4.95869 1.86384 3.76642 2.8423C2.57415 3.82077 1.75804 5.18237 1.45714 6.6951C1.15624 8.20784 1.38916 9.7781 2.11623 11.1384C2.8433 12.4986 4.01952 13.5647 5.44448 14.1549C6.86945 14.7451 8.45498 14.823 9.93094 14.3753C11.4069 13.9276 12.6819 12.9819 13.5388 11.6995C14.3957 10.4171 14.7814 8.8772 14.6303 7.34226C14.4791 5.80732 13.8004 4.37228 12.7098 3.28166L11.7772 4.21425C12.652 5.08911 13.1965 6.24025 13.3177 7.47153C13.439 8.70281 13.1296 9.93805 12.4422 10.9668C11.7549 11.9955 10.732 12.7541 9.54809 13.1132C8.36412 13.4724 7.09226 13.4099 5.9492 12.9364C4.80614 12.4629 3.86261 11.6078 3.27938 10.5166C2.69615 9.42549 2.50931 8.16587 2.75068 6.95241C2.99205 5.73894 3.64671 4.64671 4.60311 3.86181C5.55951 3.07692 6.75847 2.64792 7.99571 2.64792V1.32904Z",
    fill: "url(#paint0_linear_74_171)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_74_171",
    x1: 7.32904,
    y1: 6.99571,
    x2: 13.6624,
    y2: 6.66237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738785,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoading);
export default __webpack_public_path__ + "static/media/icon-loading.4880dcb3.svg";
export { ForwardRef as ReactComponent };